import { Navigate, useSearchParams } from 'react-router-dom';
import { Header } from '../components/Header';
import { INTENT_QUERY_KEY } from '../auth/navigation';
import { useAuthUser } from '@alchemiesolns/user-access';
import { AccountPage } from './AccountPage';

export function ProtectedAccountRoute() {
  const [searchParams] = useSearchParams();
  const bypassBilling = import.meta.env.VITE_BYPASS_BILLING === 'true';
  const { user, ready } = useAuthUser();

  if (!ready) {
    return <div className="auth-page-loading">Loading…</div>;
  }

  if ((!user || !user.emailVerified) && !bypassBilling) {
    const qs = new URLSearchParams();
    const intent = searchParams.get(INTENT_QUERY_KEY);
    if (intent) qs.set(INTENT_QUERY_KEY, intent);
    qs.set('return', '/account');
    if (user && !user.emailVerified) {
      qs.set('verify', '1');
    }
    return <Navigate to={`/login?${qs.toString()}`} replace />;
  }

  return (
    <div className="rxn-generator">
      <Header />
      <AccountPage />
    </div>
  );
}
